import { render, staticRenderFns } from "./CompassItem.vue?vue&type=template&id=26cdc918"
import script from "./CompassItem.vue?vue&type=script&lang=js"
export * from "./CompassItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports